import { get, post } from './api'

const createGame = (filename) => post('games', { filename })
const getGameInfo = (gameId) => get(`games/${gameId}`)
const getPuzzles = (page, userToken) => get(`games/puzzles?page=${page}&userToken=${userToken}`)

export default { createGame, getGameInfo, getPuzzles }
